import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { DropDownSelector } from '@lk-gtcom/ecomlab-components';
import { TextPage } from '../TextPage/TextPage';
import './TimePicker.scss';

const TimePicker = ({
    placeholder = '',
    value = '',        // "HH:MM:SS"
    onChange,          // (timeString: "HH:MM:SS") => void
    disabled = false,
    readonly = false,
}) => {
    const parseTime = (val) => {
        if (!val) return { hour: 0, minute: 0 };
        const [h, m] = val.split(':').map(Number);
        return { hour: isNaN(h) ? 0 : h, minute: isNaN(m) ? 0 : m };
    };

    const [hour, setHour] = useState(() => parseTime(value).hour);
    const [minute, setMinute] = useState(() => parseTime(value).minute);

    // Синхронизация при изменении внешнего value
    useEffect(() => {
        const { hour: h, minute: m } = parseTime(value);
        setHour(h);
        setMinute(m);
    }, [value]);

    const hoursOptions = useMemo(() =>
        Array.from({ length: 24 }, (_, i) => ({
            label: String(i).padStart(2, '0'),
            value: i,
        })), []);

    const minutesOptions = useMemo(() =>
        Array.from({ length: 60 }, (_, i) => ({
            label: String(i).padStart(2, '0'),
            value: i,
        })), []);

    const notify = useCallback((h, m) => {
        const str = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:00`;
        onChange?.(str);
    }, [onChange]);

    const handleHourChange = useCallback((opt) => {
        setHour(opt.value);
        notify(opt.value, minute);
    }, [minute, notify]);

    const handleMinuteChange = useCallback((opt) => {
        setMinute(opt.value);
        notify(hour, opt.value);
    }, [hour, notify]);

    const selectedHour = useMemo(() =>
        hoursOptions.find(opt => opt.value === hour) || hoursOptions[0],
        [hour, hoursOptions]);

    const selectedMinute = useMemo(() =>
        minutesOptions.find(opt => opt.value === minute) || minutesOptions[0],
        [minute, minutesOptions]);

    return (
        <div className="time-picker">
            {placeholder && <TextPage text={placeholder} />}
            <div className="time-picker__container">
                <div className="time-picker__selects">
                    <DropDownSelector
                        isClearable={false}
                        options_prop={hoursOptions}
                        state={selectedHour}
                        setState={handleHourChange}
                        placeholder='Часы'
                        maxWidth='100px'
                        width='100px'
                        disabled={disabled}
                        readonly={readonly}
                    />
                    <DropDownSelector
                        isClearable={false}
                        options_prop={minutesOptions}
                        state={selectedMinute}
                        setState={handleMinuteChange}
                        placeholder='Минуты'
                        maxWidth='100px'
                        width='100px'
                        disabled={disabled}
                        readonly={readonly}
                    />
                </div>
            </div>
        </div>
    );
};

export default TimePicker;